import type { ReactElement } from 'react';
import { useResourceWithCustomRouterContext } from '@atlassian/jira-resource-with-custom-router-context/src/controllers/use-resource-with-custom-router-context/index.tsx';
import { queuesNavigationItems } from '@atlassian/jira-router-resources-service-desk-queues/src/services/index.tsx';
import type { ItsmPractice } from '@atlassian/jira-servicedesk-work-category/src/common/constants.tsx';
import type { QueueResourceCustomContext } from '../../types.tsx';
import useCategorizedActionsStore from './actions-store/index.tsx';
import type { ChildrenProps } from './types.tsx';

type Props = {
	baseUrl: string;
	projectKey: string;
	category: ItsmPractice;
	children: (arg1: ChildrenProps) => ReactElement;
};

export const useCategorizedActions = (
	baseUrl: Props['baseUrl'],
	projectKey: Props['projectKey'],
	category: Props['category'],
	customContext?: QueueResourceCustomContext,
) => {
	const { update } = useResourceWithCustomRouterContext(queuesNavigationItems, customContext);
	const cachedActions = useCategorizedActionsStore(category, update, { baseUrl, projectKey });

	return [cachedActions] as const;
};

const ActionsProvider = ({ baseUrl, projectKey, category, children }: Props) => {
	const [actions] = useCategorizedActions(baseUrl, projectKey, category);
	return children(actions);
};

export default ActionsProvider;
